import { createApp, watch } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
import "primeicons/primeicons.css";
import Button from "primevue/button";
import Drawer from "primevue/drawer";
import Menu from "primevue/menu";
import InputText from "primevue/inputtext";
import "@/assets/global.css";
import "@/assets/flexboxgrid.scss";
import "@/assets/theme.css";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import Tag from "primevue/tag";
import InputNumber from "primevue/inputnumber";
import Checkbox from "primevue/checkbox";
import "primeflex/primeflex.css";
import DatePicker from "primevue/datepicker";
import Select from "primevue/select";
import Dialog from "primevue/dialog";
import Toast from "primevue/toast";
import Chart from "primevue/chart";
import Divider from "primevue/divider";
import Card from "primevue/card";
import Tabs from "primevue/tabs";
import Skeleton from "primevue/skeleton";
import ToastService from "primevue/toastservice";
import TabPanel from "primevue/tabpanel";
import Tab from "primevue/tab";

import i18n from "./i18n";

const pinia = createPinia();

const app = createApp(App);

app.component("Button", Button);
app.component("Drawer", Drawer);
app.component("Menu", Menu);
app.component("InputText", InputText);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("Row", Row);
app.component("Tag", Tag);
app.component("InputNumber", InputNumber);
app.component("Checkbox", Checkbox);
app.component("DatePicker", DatePicker);
app.component("Chart", Chart);
app.component("Select", Select);
app.component("Dialog", Dialog);
app.component("Toast", Toast);
app.component("Divider", Divider);
app.component("Card", Card);
app.component("Tabs", Tabs);
app.component("Skeleton", Skeleton);
app.component("TabPanel", TabPanel);
app.component("Tab", Tab);

app.use(ToastService);
app.use(pinia);
app.use(router);
app.use(PrimeVue, { theme: { preset: Aura } });
app.use(i18n);

// watch(
//   () => i18n.global.locale,
//   (newLocale) => {
//     const htmlRoot = document.getElementById("htmlRoot");
//     if (htmlRoot) {
//       htmlRoot.lang = newLocale;
//       htmlRoot.dir = newLocale === "ar-bh" ? "rtl" : "ltr";
//     }
//   },
//   { immediate: true }
// );

app.mount("#app");
